module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-como-02.19cb707b.jpg";